// src/pages/Accounting/Receipts/components/ReadyToUseEmail.tsx

import React, { useState } from "react";
import { Mail } from "lucide-react";
import { PALETTE } from "../constants";
import { getUserReceiptEmail } from "../utils";

interface ReadyToUseEmailProps {
  userEmail: string;
}

export function ReadyToUseEmail({ userEmail }: ReadyToUseEmailProps) {
  const [copied, setCopied] = useState(false);
  const forwardAddress = getUserReceiptEmail(userEmail);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(forwardAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div
      style={{
        maxWidth: 720,
        margin: "20px 0 10px",
        padding: "14px 16px",
        background: PALETTE.panel,
        borderRadius: 10,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 14,
      }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 7,
            background: "#fff",
            border: `1px solid ${PALETTE.line}`,
            color: PALETTE.ink2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Mail size={14} strokeWidth={2} />
        </div>
        <div>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 700,
              color: PALETTE.ink,
              margin: "0 0 2px",
            }}
          >
            Or forward any receipt email here, it works right now:
          </div>
          <div
            style={{
              fontFamily:
                "'JetBrains Mono', 'SF Mono', Consolas, monospace",
              fontSize: 12,
              color: PALETTE.velaDeep,
              fontWeight: 700,
            }}
          >
            {forwardAddress}
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={handleCopy}
        style={{
          height: 30,
          padding: "0 12px",
          borderRadius: 7,
          border: `1px solid ${PALETTE.line}`,
          background: "#fff",
          color: PALETTE.ink,
          fontSize: 11.5,
          fontWeight: 700,
          cursor: "pointer",
          fontFamily: "inherit",
          flexShrink: 0,
          minWidth: 100,
        }}
      >
        {copied ? "✓ Copied" : "Copy address"}
      </button>
    </div>
  );
}
